// The opaque ids of the Power admin onboarding contracts: non-empty strings,
// each branded so one kind of id never stands in for another.
import { Schema } from 'effect';

export const AdapterId = Schema.NonEmptyString.pipe(Schema.brand('AdapterId'));
export type AdapterId = typeof AdapterId.Type;
export const AllowedConsentId = Schema.NonEmptyString.pipe(Schema.brand('AllowedConsentId'));
export type AllowedConsentId = typeof AllowedConsentId.Type;
export const AuthorisationServerId = Schema.NonEmptyString.pipe(
  Schema.brand('AuthorisationServerId'),
);
export type AuthorisationServerId = typeof AuthorisationServerId.Type;
export const BatchId = Schema.NonEmptyString.pipe(Schema.brand('BatchId'));
export type BatchId = typeof BatchId.Type;
export const BundleId = Schema.NonEmptyString.pipe(Schema.brand('BundleId'));
export type BundleId = typeof BundleId.Type;
export const ClientId = Schema.NonEmptyString.pipe(Schema.brand('ClientId'));
export type ClientId = typeof ClientId.Type;
export const CollectionId = Schema.NonEmptyString.pipe(Schema.brand('CollectionId'));
export type CollectionId = typeof CollectionId.Type;
export const ContactId = Schema.NonEmptyString.pipe(Schema.brand('ContactId'));
export type ContactId = typeof ContactId.Type;
export const CounterpartyId = Schema.NonEmptyString.pipe(Schema.brand('CounterpartyId'));
export type CounterpartyId = typeof CounterpartyId.Type;
export const CustomerId = Schema.NonEmptyString.pipe(Schema.brand('CustomerId'));
export type CustomerId = typeof CustomerId.Type;
export const DashboardId = Schema.NonEmptyString.pipe(Schema.brand('DashboardId'));
export type DashboardId = typeof DashboardId.Type;
export const DrillId = Schema.NonEmptyString.pipe(Schema.brand('DrillId'));
export type DrillId = typeof DrillId.Type;
export const EmptyConsentId = Schema.NonEmptyString.pipe(Schema.brand('EmptyConsentId'));
export type EmptyConsentId = typeof EmptyConsentId.Type;
export const InvitationId = Schema.NonEmptyString.pipe(Schema.brand('InvitationId'));
export type InvitationId = typeof InvitationId.Type;
export const JobId = Schema.NonEmptyString.pipe(Schema.brand('JobId'));
export type JobId = typeof JobId.Type;
export const LastRunId = Schema.NonEmptyString.pipe(Schema.brand('LastRunId'));
export type LastRunId = typeof LastRunId.Type;
export const OrganisationId = Schema.NonEmptyString.pipe(Schema.brand('OrganisationId'));
export type OrganisationId = typeof OrganisationId.Type;
export const OrganizationId = Schema.NonEmptyString.pipe(Schema.brand('OrganizationId'));
export type OrganizationId = typeof OrganizationId.Type;
export const OwnerId = Schema.NonEmptyString.pipe(Schema.brand('OwnerId'));
export type OwnerId = typeof OwnerId.Type;
export const OwnerPasskeyId = Schema.NonEmptyString.pipe(Schema.brand('OwnerPasskeyId'));
export type OwnerPasskeyId = typeof OwnerPasskeyId.Type;
export const ParticipantId = Schema.NonEmptyString.pipe(Schema.brand('ParticipantId'));
export type ParticipantId = typeof ParticipantId.Type;
export const PlanId = Schema.NonEmptyString.pipe(Schema.brand('PlanId'));
export type PlanId = typeof PlanId.Type;
export const ProbeId = Schema.NonEmptyString.pipe(Schema.brand('ProbeId'));
export type ProbeId = typeof ProbeId.Type;
export const ProviderId = Schema.NonEmptyString.pipe(Schema.brand('ProviderId'));
export type ProviderId = typeof ProviderId.Type;
export const ReviewRequestId = Schema.NonEmptyString.pipe(Schema.brand('ReviewRequestId'));
export type ReviewRequestId = typeof ReviewRequestId.Type;
export const ReviewerId = Schema.NonEmptyString.pipe(Schema.brand('ReviewerId'));
export type ReviewerId = typeof ReviewerId.Type;
export const RunId = Schema.NonEmptyString.pipe(Schema.brand('RunId'));
export type RunId = typeof RunId.Type;
export const ScenarioId = Schema.NonEmptyString.pipe(Schema.brand('ScenarioId'));
export type ScenarioId = typeof ScenarioId.Type;
export const SignedByOwnerPasskeyId = Schema.NonEmptyString.pipe(
  Schema.brand('SignedByOwnerPasskeyId'),
);
export type SignedByOwnerPasskeyId = typeof SignedByOwnerPasskeyId.Type;
export const SoftwareId = Schema.NonEmptyString.pipe(Schema.brand('SoftwareId'));
export type SoftwareId = typeof SoftwareId.Type;
export const SourceId = Schema.NonEmptyString.pipe(Schema.brand('SourceId'));
export type SourceId = typeof SourceId.Type;
export const TenantId = Schema.NonEmptyString.pipe(Schema.brand('TenantId'));
export type TenantId = typeof TenantId.Type;
export const TesterId = Schema.NonEmptyString.pipe(Schema.brand('TesterId'));
export type TesterId = typeof TesterId.Type;
export const VendorId = Schema.NonEmptyString.pipe(Schema.brand('VendorId'));
export type VendorId = typeof VendorId.Type;
